import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actions as allActions } from '../../reducers';

class System extends React.Component {
  componentDidMount() {
    const {
      onFetchProfiles,
      onInitializeApplication
      // onInitializeSystem
      // onInitializeSystem
    } = this.props;
    // const onInitializeSystemCallback = () => dispatch =>
    //   Promise.all([
    //     dispatch(onFetchProfileVO()).then(fulfillProps => {
    //       if (fulfillProps.status === 200) {
    //         dispatch(onInitializeApplication());
    //       }

    //       return fulfillProps;
    //     })
    //   ]);
    // onInitializeSystem({ onInitializeSystemCallback });
    onFetchProfiles().then(fulfillProps => {
      if (fulfillProps.status === 200) {
        onInitializeApplication();
      }
    });
    // onFetchProfileVO();
    // onInitializeApplication();
  }
  componentDidUpdate() {
    window.scrollTo(0, 0);
  }
  render() {
    return <div className="system-component">{this.props.children}</div>;
  }
}

System.propTypes = {
  children: PropTypes.node
};

System.defaultProps = {
  children: null
};

const mapStateToProps = state => ({
  responses: state.cache.responses
});

export default withRouter(
  connect(
    mapStateToProps,
    allActions
  )(System)
);



// WEBPACK FOOTER //
// ./src/containers/System/index.jsx